const AD_COPY = {
    header: "Sponsored: Build your next gaming rig smarter.",
    sidebar: "Sponsored: Discover indie city-builders this week.",
    footer: "Sponsored: Accessory deals for creators and gamers."
};

export function initAdSlots(root = document) {
    const slots = root.querySelectorAll("[data-ad-slot]");

    slots.forEach((slot) => {
        const name = slot.getAttribute("data-ad-slot");
        slot.textContent = AD_COPY[name] ?? "Sponsored";
    });
}
